// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__XfytR","paymentContainer":"PaymentPage_paymentContainer__kKIJS"};